// extracted by mini-css-extract-plugin
export default {"p":"_4927b346cf d95b4c7208 _4e3bc28a41","clr":"_744b66a9b7","dls":"_3a1b4ae507"};